import { ArrowLeft } from "@carbon/icons-react";
import { Toolbar, ToolbarAction, ToolbarActions } from "@flaminem/ui-components";
import { FC } from "react";
import { useSearchParams } from "react-router-dom";

import AlertsAndExecutionsResultsView, {
  AlertsAndExecutionsResultsViewProps,
} from "src/dynamic-view-renderer/Widgets/AlertsAndExecutionsWidget/AlertsAndExecutionsResultsView";
import WidgetContainer, {
  WidgetContainerProps,
} from "src/dynamic-view-renderer/Widgets/WidgetContainer.tsx";
import WidgetRenderer from "src/dynamic-view-renderer/Widgets/WidgetRenderer.tsx";
import { useT } from "src/internationalization";
import { ScenarioExecutionResultWithCase } from "src/types/scenario";

export type AlertsAndExecutionsWidgetProps = {
  data?: AlertsAndExecutionsResultsViewProps;
} & Omit<WidgetContainerProps, "children">;

export const AlertsAndExecutionsWidget: FC<AlertsAndExecutionsWidgetProps> = ({
  data,
  ...containerProps
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const t = useT();

  const executionResults = data?.executionResults;
  const executionResultId = searchParams.get("executionId");

  const currentExecutionResult =
    executionResults?.find((result) => result.id === executionResultId) ?? null;

  const handleBack = () => {
    searchParams.delete("executionId");
    setSearchParams(searchParams);
  };
  return !currentExecutionResult ? (
    <WidgetContainer {...containerProps} header={<></>} className="!p-0">
      <AlertsAndExecutionsResultsView {...data} snapshotMode={data?.snapshotMode} />
    </WidgetContainer>
  ) : (
    <div className="flex flex-col w-full">
      <Toolbar className="justify-start bg-background">
        <ToolbarActions className={"flex items-center gap-2"}>
          <ToolbarAction label={t("component.button.back")} onClick={handleBack}>
            <ArrowLeft />
          </ToolbarAction>
          <span>{currentExecutionResult.scenarioVersion?.scenario?.name}</span>
        </ToolbarActions>
      </Toolbar>
      <WidgetRenderer
        data={{
          widgetsData: {
            executionDetails: {
              executionResult: currentExecutionResult as ScenarioExecutionResultWithCase,
              selectedCase: data?.selectedCase,
            },
          },
        }}
        rowConfiguration={{ widgets: [{ widgetCode: "executionDetails" }] }}
        widgetConfig={{ widgetCode: "executionDetails" }}
      />
    </div>
  );
};
